const FALLBACK_TIME_ZONES = [
  'UTC',
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
];

type IntlWithSupportedValues = typeof Intl & {
  supportedValuesOf?: (key: string) => string[];
};

export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

export function getSupportedTimeZones(preferredTimeZone?: string): string[] {
  const zones = new Set<string>();

  if (preferredTimeZone) {
    zones.add(preferredTimeZone);
  }

  try {
    const intlWithSupportedValues = Intl as IntlWithSupportedValues;
    const supportedTimeZones =
      typeof intlWithSupportedValues.supportedValuesOf === 'function'
        ? intlWithSupportedValues.supportedValuesOf('timeZone')
        : FALLBACK_TIME_ZONES;

    supportedTimeZones.forEach(timeZone => zones.add(timeZone));
  } catch {
    FALLBACK_TIME_ZONES.forEach(timeZone => zones.add(timeZone));
  }

  return Array.from(zones);
}
